export default __webpack_public_path__ + "static/media/financialsituation1Img6.32859744.png";